import DataTable from './components/DataTable';
import PageSize from './components/PageSize';

DataTable.PageSize = PageSize;

export { PageSize };

export default DataTable;
